var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 107,
    viewBox: "0 0 114 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5754 28.9122L43.2138 36.5561L53.2508 45.0549L45.0643 56.7263L50.5425 61.3649L58.729 49.6936L81.2547 68.7673C83.8086 70.9298 86.2421 72.4226 88.555 73.2457C90.8616 74.0198 93.0188 74.2524 95.0265 73.9436C97.0598 73.6565 98.9403 72.8907 100.668 71.6462C102.39 70.3526 103.942 68.7196 105.326 66.7469C106.152 65.5688 106.927 64.3475 107.652 63.0829C108.395 61.7909 109.039 60.5242 109.584 59.2827C110.155 58.0628 110.63 56.8926 111.009 55.7723C111.362 54.6303 111.581 53.5928 111.665 52.6599L105.897 49.479C105.673 50.0313 105.377 50.7421 105.012 51.6116C104.64 52.4321 104.23 53.3074 103.781 54.2374C103.313 55.1949 102.822 56.1552 102.309 57.1184C101.771 58.06 101.214 58.9418 100.637 59.7637C99.8493 60.887 98.9722 61.8474 98.0057 62.6448C97.0585 63.4149 95.9966 63.9132 94.8201 64.1397C93.669 64.3878 92.4162 64.2877 91.0616 63.8394C89.707 63.3911 88.2253 62.4858 86.6163 61.1234L64.0905 42.0497L75.9667 25.118L70.4885 20.4793L58.6123 37.411L48.5754 28.9122Z",
    fill: "#24354F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37919,
    y1: -4.37919,
    x2: 82.6032,
    y2: -4.37919,
    transform: "matrix(0.776243 0.631395 -0.558463 0.828838 16.0663 45.3956)",
    stroke: "#5BB8DF",
    strokeWidth: 8.75838,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37919,
    y1: -4.37919,
    x2: 91.9909,
    y2: -4.37919,
    transform: "matrix(-0.571396 0.819967 -0.765705 -0.644141 73.7557 15.5265)",
    stroke: "#5BB8DF",
    strokeWidth: 8.75838,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c51d324182f240938a8302af6a1c053.svg";
export { ForwardRef as ReactComponent };